import React from 'react'
import PropTypes from 'prop-types'
import { graphql, Link } from 'gatsby'
import styled from 'styled-components'
import parse from 'html-react-parser'
import Img from 'gatsby-image'
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion'
import { device } from '../components/Breakpoints'
import { Breadcrumb } from '../components/Breadcrumb'
import { colors } from '../components/Colors'
import imguticardiopatia from '../img/equipe-a.jpg'
import imgcardiopatiabebe from '../img/b-cardiopatia.jpg'
import imgcardiopatiadedo from '../img/cardiopatia_dedo.jpg'
import imgaltacomplexidade from '../img/cardiopatia-complexidade.jpg'
import imginfografico from '../img/infografico_cardiopatiacongenita.jpg'
import iconcromossomo from '../icons/icon-cromossomo.svg'
import icondna from '../icons/icon-dna.svg'
import PageHeader from '../components/PageHeader'
import Layout from '../components/Layout'
import VejaTambem from '../components/VejaTambem'
import CentralAtendimento from '../components/CentralAtendimento'

const Container = styled.section`
  width: 100%;
  margin-bottom: 2em;
`

const GroupContent = styled.section`
  padding: 2em 0;
  ul {
    margin-top: 0;
    padding-top: 20px;
    color: ${colors.cinza};
  }
  li {
    color: ${colors.cinza};
  }
  @media ${device.mobileL} {
    .imgOrder {
      order: 1;
    }
    .txtOrder {
      order: 2;
    }
  }
  .info {
    display: flex;
    justify-content: center;
    img {
      @media ${device.mobileL} {
        width: 100%;
      }
    }
  }
  .inner {
    display: flex;
    div {
      width: 60%;
      padding-top: 40px;
      padding-right: 30px;
      @media ${device.mobileL} {
        width: 100%;
        padding-right: 0px;
      }
    }
    h2 {
      color: #fff8d1;
    }
    img {
      max-height: 250px;
      padding: 0 60px;
      @media ${device.mobileL} {
        padding: 0;
        width: 100%;
      }
    }
    @media ${device.mobileL} {
      display: block;
    }
  }
  .inner {
    justify-content: space-between;
    p {
      font-size: 0.8em;
    }
    @media ${device.mobileL} {
      flex-wrap: wrap;
    }
    h2 {
      color: #8e8fc7;
      margin-top: 0;
    }
    .maternidade {
      width: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      margin: 40px 0;
      padding: 0;
      div {
        padding: 0 2em 1em 2em;
        margin: 0 30px 30px 0;
        background-color: white;
        box-shadow: 0px 0px 11px 0px rgba(0, 0, 0, 0.5);
        width: 22%;
        box-sizing: border-box;
        @media ${device.mobileL} {
          width: 100%;
          margin: 0 0 30px 0;
        }
      }
      p {
        width: 100%;
        color: #4a4a4a;
        text-align: left;
        position: relative;
        top: 0em;
      }
    }
  }
  .fonte {
    font-size: 0.2em;
  }
  .quadro {
    background-color: #ffffff;
    padding: 2em;
    overflow: hidden;
    box-shadow: 0px 31px 95px -40px rgba(0, 0, 0, 0.75);
    margin-bottom: 30px;
  }
  .cuidados {
    display: flex;
    align-items: center;
    @media ${device.mobileL} {
      flex-wrap: wrap;
      max-height: 100%;
    }
    h3 {
      color: ${colors.lilas};
      position: relative;
      margin: 0;
      font-size: 1em;
      padding: 2em;
      :before {
        position: absolute;
        content: '';
        top: 24px;
        left: 38px;
        border: 1px solid ${colors.lilas};
        width: 5%;
        opacity: 0.5;
        @media ${device.mobileL} {
          left: 0px;
        }
      }
      :after {
        position: absolute;
        content: '';
        bottom: 24px;
        left: 38px;
        border: 1px solid ${colors.lilas};
        width: 5%;
        opacity: 0.5;
        @media ${device.mobileL} {
          left: 0px;
        }
      }
      @media ${device.mobileL} {
        padding: 2em 5px 2em 0em;
      }
    }
    div {
      height: 100%;
      @media ${device.mobileL} {
        order: 1;
        width: 100%;
      }
    }
    @media ${device.mobileL} {
      justify-content: center;
    }
  }
  .estrutura {
    display: flex;
    div {
      width: 55%;
      padding-right: 30px;
      @media ${device.mobileL} {
        width: 100%;
        padding-right: 0px;
      }
    }
    img {
      width: 45%;
      @media ${device.mobileL} {
        width: 100%;
      }
    }
    a {
      color: #539e9f;
      text-decoration: none;
    }
    @media ${device.mobileL} {
      flex-wrap: wrap;
    }
  }
  .registro {
    background-color: #ffffff;
    padding: 20px 0;
    .cuidados {
      background-color: none;
      box-shadow: none;
      img {
        padding: 0 30px;
      }
      p {
        padding: 0 20px 0px 0;
        color: ${colors.cinza};
      }
    }
  }
  .fade {
    position: relative;
    padding: 0;
    :after {
      content: ' ';
      z-index: 10;
      display: block;
      position: absolute;
      height: 100%;
      top: 0;
      left: 0;
      right: 0;
      background-image: linear-gradient(
        to right,
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 1)
      );
      @media ${device.mobileL} {
        background-image: linear-gradient(
          to bottom,
          rgba(255, 255, 255, 1),
          rgba(255, 255, 255, 0),
          rgba(255, 255, 255, 0)
        );
      }
    }
    @media ${device.mobileL} {
      order: 2;
      width: 100%;
    }
    img {
      display: block;
    }
  }
  .accordion__panel {
    div {
      padding: 1em;
      @media ${device.mobileL} {
        padding-right: 2em;
      }
    }
  }
  :nth-of-type(2) {
    background: ${colors.laranjaGradienteReverso};
    color: #ffffff;
  }
  :nth-of-type(3) {
    h2 {
      color: ${colors.lilas};
    }
    .fonte {
      p {
        font-size: 14px !important;
      }
    }
    p {
      margin-bottom: 0;
    }
    h4 {
      font-size: 2em;
      margin: 20px 0;
      color: #539e9f;
    }
  }
  :nth-of-type(4) {
    background: ${colors.verdeGradiente};
    color: #ffffff;
    h2 {
      color: #fff8d1;
    }
  }

  :nth-of-type(5) {
    h2 {
      color: #fa7373;
    }
  }
  :nth-of-type(6) {
    background: ${colors.lilasGradiente};
    h2 {
      color: #fff8d1;
    }
    h4 {
      color: #539e9f;
      padding-top: 30px;
    }
    ul {
      margin-right: 70px;
      @media ${device.mobileL} {
        margin: 0;
        padding: 0px 0 0 20px;
      }
    }
  }
  :nth-of-type(7) {
    h2 {
      color: #fa7373;
    }
    .estrutura {
      margin-bottom: 30px;
    }
    strong {
      color: ${colors.lilas};
    }
    a {
      color: ${colors.lilas};
    }
  }
  :nth-of-type(8) {
    background: ${colors.laranjaGradiente};
    h2 {
      color: #fff8d1;
    }
    p {
      padding: 1em;
      margin-bottom: 0;
    }
  }
  :nth-of-type(9) {
    h2 {
      color: #fa7373;
    }
    .estrutura {
      margin-bottom: 30px;
    }
    strong {
      color: ${colors.lilas};
    }
  }
  :nth-of-type(10) {
    background: ${colors.verdeGradiente};
    a {
      color: ${colors.lilas};
    }
    p {
      color: #ffffff;
    }
    h2 {
      color: #fff8d1;
    }
    .cuidados {
      margin: 20px 0;
      margin-bottom: 40px;
      background-color: #ffffff;
      overflow: hidden;
      box-shadow: 0px 31px 95px -40px rgba(0, 0, 0, 0.75);
      div {
        padding: 1em;
        @media ${device.mobileL} {
          padding: 2em;
        }
      }
      img {
        @media ${device.mobileL} {
          width: 124%;
        }
      }
      p {
        color: ${colors.cinza};
      }
      h3 {
        padding: 1em 0 2em 0;
        :before {
          top: 0px;
          left: 0;
        }
        :after {
          left: 0;
        }
      }
    }
  }

  @media ${device.mobileL} {
    padding: 2em;
    p,
    h3 {
      text-align: left;
    }
  }
`

export const CardiopatiaCongenitaTemplate = ({
  title,
  content,
  slug,
  image,
  color,
  area = 'Blog',
  sessoes,
}) => {
  const crumbs = [
    { id: 1, link: '/', title: 'Home', icon: true },
    { id: 2, link: '#', title: area, icon: true },
    { id: 3, link: slug, title },
  ]
  return (
    <>
      <Container>
        <Breadcrumb crumbs={crumbs} />

        <PageHeader
          title={title}
          content={content}
          image={image}
          color={color}
          txtColor="cinza"
          height="124px"
          right="0"
          bottom="0"
          imgWidth="34.3%"
          overflow="visible"
          imgInner
          mobileTop="-16%"
        />
        <GroupContent>
          <div className="center">{parse(sessoes[0].texto)}</div>
        </GroupContent>
        <GroupContent>
          <div className="center">
            <h2>{parse(sessoes[1].tituloDaSessao)}</h2>
            <div className="inner">
              <div className=" maternidade">
                {sessoes[1].acordeao.map((item, index) => (
                  <div key={index}>
                    <h4>{parse(item.titulo)}</h4>
                    {parse(item.conteudo)}
                  </div>
                ))}
              </div>
            </div>
            <div className="fonte">{parse(sessoes[2].texto)}</div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center">
            <h2>{parse(sessoes[3].tituloDaSessao)}</h2>
          </div>
          <div className="estrutura center">
            <div className="txtOrder">{parse(sessoes[3].texto)}</div>
            {sessoes[3].imagemDaSessao.localFile ? (
              <Img
                fluid={
                  sessoes[3].imagemDaSessao.localFile.childImageSharp.fluid
                }
                alt="Cardiopatia congênita"
                className="imgOrder offsetImgMid"
              />
            ) : (
              <img
                src={sessoes[3].imagemDaSessao.sourceUrl}
                alt="Cardiopatia congênita"
                className="imgOrder offsetImgMid"
              />
            )}
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center">
            <h2>{parse(sessoes[4].tituloDaSessao)}</h2>
            <Accordion allowZeroExpanded="true" allowMultipleExpanded="true">
              {sessoes[4].acordeao.map((item, index) => (
                <AccordionItem key={index}>
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      <h3>{parse(item.titulo)}</h3>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div>{parse(item.conteudo)}</div>
                  </AccordionItemPanel>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center">
            <h2>{parse(sessoes[5].tituloDaSessao)}</h2>
            <div className="quadro">
              <div className="cuidados">
                <img src={icondna} alt="Ultrassom" />
                <h3>{parse(sessoes[6].tituloDaSessao)}</h3>
              </div>
              <div>{parse(sessoes[6].texto)}</div>
            </div>
            <div className="quadro">
              <div className="cuidados">
                <img src={iconcromossomo} alt="Ultrassom" />
                <h3>{parse(sessoes[7].tituloDaSessao)}</h3>
              </div>
              <div>{parse(sessoes[7].texto)}</div>
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center">
            <h2>{parse(sessoes[8].tituloDaSessao)}</h2>
            <div className="estrutura">
              <div>{parse(sessoes[8].texto)}</div>
              {sessoes[8].imagemDaSessao.localFile ? (
                <Img
                  fluid={
                    sessoes[8].imagemDaSessao.localFile.childImageSharp.fluid
                  }
                  alt="Alta Complexidade"
                  className="offsetImgEnd2"
                />
              ) : (
                <img
                  src={sessoes[8].imagemDaSessao.sourceUrl}
                  alt="Alta Complexidade"
                  className="offsetImgEnd2"
                />
              )}
            </div>
            {parse(sessoes[9].texto)}
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center">
            <h2>{parse(sessoes[10].tituloDaSessao)}</h2>
            <Accordion allowZeroExpanded="true" allowMultipleExpanded="true">
              {sessoes[10].acordeao.map((item, index) => (
                <AccordionItem key={index}>
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      <h3>{parse(item.titulo)}</h3>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div>{parse(item.conteudo)}</div>
                  </AccordionItemPanel>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center">
            <h2>{parse(sessoes[11].tituloDaSessao)}</h2>
            <div className="estrutura">
              <div>{parse(sessoes[11].texto)}</div>
              {sessoes[11].imagemDaSessao.localFile ? (
                <Img
                  fluid={
                    sessoes[11].imagemDaSessao.localFile.childImageSharp.fluid
                  }
                  alt="Cardiopatia"
                  className="offsetImgEnd2"
                />
              ) : (
                <img
                  src={sessoes[11].imagemDaSessao.sourceUrl}
                  alt="Cardiopatia"
                  className="offsetImgEnd2"
                />
              )}
            </div>
            {parse(sessoes[12].texto)}
            <div className="info">
              <img src={sessoes[12].imagemDaSessao.sourceUrl} alt="Ultrassom" />
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center">
            <h2>{parse(sessoes[13].tituloDaSessao)}</h2>
            {parse(sessoes[13].texto)}
            <div className="cuidados">
              <section className="fade">
                <img
                  src={sessoes[14].imagemDaSessao.sourceUrl}
                  alt="Ultrassom"
                />
              </section>
              <div>
                <h3>{parse(sessoes[14].tituloDaSessao)}</h3>
                {parse(sessoes[14].texto)}
              </div>
            </div>
            {parse(sessoes[15].texto)}
          </div>
        </GroupContent>
        <CentralAtendimento />
      </Container>
    </>
  )
}

CardiopatiaCongenitaTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
}

const CardiopatiaCongenita = ({ data, location }) => {
  const { siteMetadata: site } = data.site
  const { wpPage: page } = data
  const image = page.opEsDaPGina.imagem ? page.opEsDaPGina.imagem.sourceUrl : ''
  const area = location.state ? location.state.area : page.opEsDaPGina.area
  const { paginasRelacionadas } = page.opEsDaPGina
  const { sessaoCustomizada: sessoes } = page.SessoesCustomizadas
  const description = page.excerpt
    ? page.excerpt.replace(/<\/?[^>]+(>|$)/g, '').replace(/\n/g, '')
    : ''

  return (
    <Layout title={`${page.title} – ${site.title}`} description={description}>
      <CardiopatiaCongenitaTemplate
        title={page.title}
        content={page.content}
        image={image}
        slug={page.slug}
        color={page.opEsDaPGina.corDoCabecalho}
        area={area}
        sessoes={sessoes}
      />
      <VejaTambem relatedPages={paginasRelacionadas} />
    </Layout>
  )
}

CardiopatiaCongenita.propTypes = {
  data: PropTypes.object.isRequired,
}

export default CardiopatiaCongenita

export const CardiopatiaCongenitaQuery = graphql`
  query CardiopatiaCongenitaById($id: String!) {
    site {
      siteMetadata {
        url
        title
      }
    }
    wpPage(id: { eq: $id }) {
      title
      content
      slug
      excerpt
      SessoesCustomizadas {
        sessaoCustomizada {
          texto
          tituloDaSessao
          imagemDaSessao {
            sourceUrl
            localFile {
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          acordeao {
            titulo
            conteudo
          }
        }
      }
      opEsDaPGina {
        corDoCabecalho
        area
        imagem {
          sourceUrl
        }
        paginasRelacionadas {
          ... on WpPage {
            id
            title
            slug
          }
        }
      }
    }
  }
`
